import React from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/usePageMeta";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display font-black text-xl text-white mb-2">{title}</h2>
    <div className="text-sm text-white/80 leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function CookiePolicy() {
  usePageMeta({
    title: "Zásady používání cookies — CARSPA CLUB",
    description: "Jak CARSPA CLUB používá soubory cookies pro provoz webu, anonymní analytiku (PostHog) a marketing, a jak svůj souhlas kdykoliv změníte.",
    path: "/zasady-cookies",
  });
  const openSettings = () => window.dispatchEvent(new Event("open-cookie-settings"));
  return (
    <div className="min-h-screen bg-brand-bg text-white" data-testid="cookie-policy">
      <header className="border-b border-brand-border">
        <div className="max-w-[820px] mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="font-display font-black flex items-center gap-2"><span className="w-2 h-2 bg-brand-accent" />CARSPA CLUB</Link>
          <Link to="/" className="text-xs text-brand-muted hover:text-brand-accent">← Zpět na web</Link>
        </div>
      </header>
      <main className="max-w-[820px] mx-auto px-6 py-12">
        <div className="text-xs uppercase tracking-[0.3em] text-brand-accent mb-3">Ochrana soukromí</div>
        <h1 className="font-display font-black text-3xl sm:text-4xl mb-8">Zásady používání cookies</h1>

        <Section title="Co jsou cookies">
          <p>Cookies jsou malé textové soubory, které web ukládá do vašeho prohlížeče. Slouží k zajištění funkčnosti webu, k měření návštěvnosti a k marketingu. Některé jsou nezbytné, ostatní spouštíme jen s vaším souhlasem.</p>
        </Section>

        <Section title="Jaké cookies používáme">
          <p><b className="text-white">Nezbytné</b> — zajišťují základní provoz webu (přihlášení do členské sekce, bezpečnost). Jsou vždy aktivní.</p>
          <p><b className="text-white">Analytické</b> — anonymní statistiky návštěvnosti pomocí nástroje PostHog. Pomáhají nám web zlepšovat. Spouštíme je jen s vaším souhlasem.</p>
          <p><b className="text-white">Marketingové</b> — měření účinnosti kampaní a zobrazení relevantních nabídek. Spouštíme je jen s vaším souhlasem.</p>
        </Section>

        <Section title="Váš souhlas">
          <p>Při první návštěvě si vyberete, které kategorie povolíte. Bez souhlasu neběží analytika ani marketing. Svou volbu můžete kdykoliv změnit:</p>
          <button onClick={openSettings} data-testid="cookie-reopen" className="mt-2 h-10 px-4 bg-brand-accent text-black text-sm font-semibold hover:bg-brand-accentHover transition-colors">Změnit nastavení cookies</button>
        </Section>

        <Section title="Správa v prohlížeči">
          <p>Cookies můžete také spravovat nebo mazat přímo v nastavení svého prohlížeče. Odmítnutí některých cookies může ovlivnit funkčnost webu.</p>
        </Section>

        <Section title="Kontakt">
          <p>V případě dotazů k ochraně osobních údajů nás kontaktujte na <a href="mailto:info@automyckacestlice.cz" className="text-brand-accent hover:underline">info@automyckacestlice.cz</a>.</p>
        </Section>
      </main>
    </div>
  );
}
